import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MaterialModule } from 'carehub-shared/material.module';
import { SharedModule } from 'carehub-shared/shared.module';
import { EntityHistoryComponent } from './components/entity-history.component';

export const routes: Routes = [
  {
    path: '',
    component: EntityHistoryComponent,
  },
];

@NgModule({
  imports: [SharedModule, RouterModule.forChild(routes), MaterialModule],
  declarations: [EntityHistoryComponent],
})
export class EntityHistorySubModule {
  constructor() {}
}
